import { render, staticRenderFns } from "./crm-document.vue?vue&type=template&id=30427758&"
import script from "./crm-document.vue?vue&type=script&lang=js&"
export * from "./crm-document.vue?vue&type=script&lang=js&"
import style0 from "./crm-document.vue?vue&type=style&index=0&id=30427758&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports